import React from 'react';
import { Box, Card, IconButton, Link, Typography } from '@mui/material';
import TrashIcon from '../../assets/images/icons/TrashIcon.svg';
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import { isAdmin } from '../../helpers/helpers_general.js';

import './category-card-list.scss';

const CategoriesCardList = ({ categories, setCategory }) => (
  <Box className="card-container">
    {categories.map((category, index) => (
      <Box key={`${category.id}-${index}`} className="category-wrapper">
        <Card className="category-card">
          <Box
            className="category-card-bg"
            style={{
              backgroundImage: category.background_url
                ? `url(${category.background_url})`
                : undefined,
            }}
          >
            <Box className="category-card-overlay" />

            {isAdmin() && (
              <Box className="category-action-btns">
                <IconButton
                  className="category-action-btn"
                  aria-label="editar"
                  onClick={() =>
                    setCategory(prevState => ({
                      ...prevState,
                      showEditModal: true,
                      categorySelected: category,
                    }))
                  }
                >
                  <img src={EditIcon} alt="Editar Categoria" />
                </IconButton>
                <IconButton
                  className="category-action-btn category-action-btn--danger"
                  aria-label="excluir"
                  onClick={() =>
                    setCategory(prevState => ({
                      ...prevState,
                      showModal: true,
                      categorySlugSelected: category.slug,
                      categoryIdSelected: category.id,
                    }))
                  }
                >
                  <img src={TrashIcon} alt="Deletar Categoria" />
                </IconButton>
              </Box>
            )}

            <Link
              href={'/category/' + category.id}
              sx={{ textDecoration: 'none', width: '100%', height: '100%' }}
            >
              <Box className="category-card-content">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <Typography className="category-title" variant="h2">
                    {category.slug}
                  </Typography>
                  {category.new_content_count > 0 && (
                    <Box className="category-new-badge">
                      +{category.new_content_count} esta semana
                    </Box>
                  )}
                </Box>

                {category.description && (
                  <Typography className="category-description">
                    {category.description}
                  </Typography>
                )}

                <Typography className="category-count">
                  {category.content_count ?? 0}{' '}
                  {(category.content_count ?? 0) === 1 ? 'conteúdo' : 'conteúdos'}
                </Typography>
              </Box>
            </Link>
          </Box>
        </Card>
      </Box>
    ))}
  </Box>
);

export default CategoriesCardList;
